module.exports = __webpack_public_path__ + "img/quienes1.07b3feb2.jpg";